import { render, staticRenderFns } from "./formYear.vue?vue&type=template&id=22e58c12&"
import script from "./formYear.vue?vue&type=script&lang=js&"
export * from "./formYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports